import {
  compose as lcompose,
  eq as leq,
  find as lfind,
  filter as lfilter,
  negate as lnegate,
  isEmpty as lisEmpty,
  size as lsize,
  lt as llt,
} from 'lodash/fp';
import { path, pathOr, not, prop } from 'rambda';
import { IApiCallStatus, IDeaEditMode, IDeaInfo } from '../common';
import { IRequestApiCallStatus, IRequestState } from './requestReducer';

export * from './consent';
export * from './constants';
export * from './disableSaves';
export * from './justificationOptions';
export * from './requestActions';
export * from './requestReducer';
export * from './requestStateHelpers';

export * from './useSubmitRequest';
export * from './useEmploymentVerification';
export * from './useEmploymentVerificationView';
export * from './usePreviousRequest';
export * from './useConfirmSubmitRequest';
export * from './useSetRequest';

export * from './AddDeaNum';
export * from './RegistrationNo';
export * from './RegistrationNosEnroll';
export * from './UploadFile';
export * from './ImportFile';
export * from './Justification';
export * from './SaveRequest';

export const roleRequireDocument = (role: string) =>
  lfind<string>(leq(role))(['POA']) !== void 0;

export const requestRequireDocument = lcompose(
  roleRequireDocument,
  path('role')
);
export const stateRequireDocument = lcompose(
  requestRequireDocument,
  path('request')
);

export const saveRequestStatus: (state: IRequestState) => IApiCallStatus =
  lcompose(
    prop('apiCallStatus'), //path('apiCallStatus')({apiCallStatus:null}) === void 0, prop('apiCallStatus')({apiCallStatus:null}) === null
    lfind<IRequestApiCallStatus>({ type: 'SaveRequest' }),
    pathOr<IRequestApiCallStatus[]>([], 'apiCallStatus')
  );

// const deaNumRule = /^[A-Z]{2}[0-9]{7}$/i;

export const validateDeaNum = (items: IDeaEditMode[]) => (a: IDeaEditMode) => {
  if (
    lcompose(
      lfind<IDeaEditMode>({ deaNum: a.deaNum }),
      lfilter<IDeaEditMode>(lcompose(lnegate(leq(a.key)), path('key')))
    )(items) !== void 0
  ) {
    return 'Duplicate DEA Registration Number';
  }

  // if (!deaNumRule.test(a.deaNum)) {
  if (a.deaNum.length !== 9) {
    // return 'DEA Registration Number starts with 2 characters then 7 digits.';
    return 'DEA Registration Number should be 9 characters long.';
  }

  return null;
};

export const someDeaNumError = lfind<IDeaEditMode>(
  lcompose(lnegate(lisEmpty), path('msgText'))
);

export const allDeaNumSelected = lcompose(
  lisEmpty,
  lfind<IDeaEditMode>(lcompose(lnegate(Boolean), path('selected')))
);

export const errorInDeaInfos = lcompose(
  llt(0),
  lsize,
  lfilter<IDeaInfo>(lcompose(not, lisEmpty, pathOr(null, 'msgCode'))),
  pathOr([], 'deaInfos')
);

export const changeValidated = lcompose(not, errorInDeaInfos);
